module.exports = __webpack_public_path__ + "static/media/different-sports-image.480cdc06.webp";